// Wall of Fame — dati di default (fallback se il DB è vuoto); gestibili da admin
export const DEFAULT_WALL_OF_FAME = [
  {
    id: 1,
    src: "https://static.wixstatic.com/media/e93d0f_eb73361724a04016b48836f0efa203d5~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_eb73361724a04016b48836f0efa203d5~mv2.gif",
    caption: "ENSI - Vincitore",
    year: "2003",
    spotifyUrl: "https://open.spotify.com/search/Ensi%20rapper"
  },
  {
    id: 2,
    src: "https://static.wixstatic.com/media/e93d0f_d5b1bbd2517e438eadf675fea7e1b087~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_d5b1bbd2517e438eadf675fea7e1b087~mv2.gif",
    caption: "MONDOMARCIO - Vincitore",
    year: "2003",
    spotifyUrl: "https://open.spotify.com/search/Mondo%20Marcio"
  },
  {
    id: 3,
    src: "https://static.wixstatic.com/media/e93d0f_f4b2442b14b34933a6e4800e151e707c~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_f4b2442b14b34933a6e4800e151e707c~mv2.gif",
    caption: "CLEMENTINO - Vincitore",
    year: "2004",
    spotifyUrl: "https://open.spotify.com/search/Clementino"
  },
  {
    id: 4,
    src: "https://static.wixstatic.com/media/e93d0f_ec4499d2231f427dbb3260843aebc081~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_ec4499d2231f427dbb3260843aebc081~mv2.gif",
    caption: "JULY B - Vincitore",
    year: "2006",
    spotifyUrl: "https://open.spotify.com/artist/6xazM4LconZEDcZk0Td6DD"
  },
  {
    id: 5,
    src: "https://static.wixstatic.com/media/e93d0f_15254ce8cded481abf98ba3266cb1f97~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_15254ce8cded481abf98ba3266cb1f97~mv2.gif",
    caption: "EMIS KILLA - Vincitore",
    year: "2007",
    spotifyUrl: "https://open.spotify.com/search/Emis%20Killa"
  },
  {
    id: 6,
    src: "https://static.wixstatic.com/media/e93d0f_e8fb8e15613149b583800ed2c6131522~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_e8fb8e15613149b583800ed2c6131522~mv2.gif",
    caption: "NOEMA - Vincitore",
    year: "2008",
    spotifyUrl: "https://open.spotify.com/intl-it/artist/0lqbBq1PQu6YQwrEXJKWHw"
  },
  {
    id: 7,
    src: "https://static.wixstatic.com/media/e93d0f_b924f9e267bf4969b5bf3a48081e68c0~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_b924f9e267bf4969b5bf3a48081e68c0~mv2.gif",
    caption: "KENZIE - Vincitore",
    year: "2010",
    spotifyUrl: "https://open.spotify.com/search/Kenzie%20rapper"
  },
  {
    id: 8,
    src: "https://static.wixstatic.com/media/e93d0f_93faa0123e524ea4bad903246a1a5a38~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_93faa0123e524ea4bad903246a1a5a38~mv2.gif",
    caption: "CANE SECCO - Vincitore",
    year: "2009",
    spotifyUrl: "https://open.spotify.com/search/Cane%20Secco"
  },
  {
    id: 9,
    src: "https://static.wixstatic.com/media/e93d0f_9d147ddecbb24b86a4dfefa4c9121701~mv2.gif/v1/fit/w_480,h_1371,q_90,enc_avif,quality_auto/e93d0f_9d147ddecbb24b86a4dfefa4c9121701~mv2.gif",
    caption: "MORENO - Vincitore",
    year: "2011",
    spotifyUrl: "https://open.spotify.com/search/Moreno%20rapper"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/p7cl0f2c_11.gif",
    caption: "FAT MC - Vincitore",
    year: "2011",
    spotifyUrl: "https://open.spotify.com/search/Fat%20MC"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/gy97vdk7_12.gif",
    caption: "LETHAL V - Vincitore",
    year: "2013",
    spotifyUrl: "https://open.spotify.com/search/Lethal%20V"
  },
  {
    id: 12,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/i7w78lzi_13.gif",
    caption: "MORBO - Vincitore",
    year: "2015",
    spotifyUrl: "https://open.spotify.com/intl-it/artist/1BETMlLbXTAXe5CJTvC9fH"
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/tmhw0fy8_14.gif",
    caption: "MAIK BRAIN - Vincitore",
    year: "2015",
    spotifyUrl: "https://open.spotify.com/search/Maik%20Brain"
  },
  {
    id: 14,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/6sqkujsl_15.gif",
    caption: "REIVEN - Vincitore",
    year: "2016",
    spotifyUrl: "https://open.spotify.com/search/Reiven%20rapper"
  },
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/cy9ku545_16.gif",
    caption: "SHEKKERO - Vincitore",
    year: "2017",
    spotifyUrl: "https://open.spotify.com/search/Shekkero"
  },
  {
    id: 16,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/xnlhvzg4_17.gif",
    caption: "BLNKAY - Vincitore",
    year: "2018",
    spotifyUrl: "https://open.spotify.com/search/Blnkay"
  },
  {
    id: 17,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/odvvdax8_18.gif",
    caption: "FRENK - Vincitore",
    year: "2019",
    spotifyUrl: "https://open.spotify.com/intl-it/track/3Bw16ssQpNwWby25HIeNkX"
  },
  {
    id: 18,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/yvhs4hne_19.gif",
    caption: "KYIN - Vincitore",
    year: "2022",
    spotifyUrl: "https://open.spotify.com/track/3SHWEsBFZgMiB2ge6PB2bC"
  },
  {
    id: 21,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/2hpynhzl_nuova%20HALL%20OF%20FAME%20%282%29.gif",
    caption: "HIGHER - Vincitore",
    year: "2023",
    spotifyUrl: "https://open.spotify.com/intl-it/artist/2J20kQmO3eDJ8v2PGWjXjU"
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/hocpcwyf_21.gif",
    caption: "REDRUM - Vincitore",
    year: "2024",
    spotifyUrl: "https://youtu.be/zkTwxnVGidw?si=UkHl1uJQfhoF3OTb"
  },
  {
    id: 20,
    src: "https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/9v9k8y7k_22.gif",
    caption: "GRIZLY - Vincitore",
    year: "2025",
    spotifyUrl: "https://www.instagram.com/p/DW3qyQ-DsZR/"
  },
  {
    id: 99,
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_site-mirror-165/artifacts/d87xqfww_nuova%20HALL%20OF%20FAME.mp4",
    isVideo: true,
    caption: "CHAIN - Vincitore",
    year: "2026",
    spotifyUrl: "https://www.instagram.com/chainyurei/"
  }
];
